import { defineMessages } from 'react-intl';

const messages = defineMessages({
  title: {
    id: 'searchpage.title',
    defaultMessage: 'Store | PC Game Deals and Steam Key Promotions | Fanatical',
  },
  saleTitle: {
    id: 'searchpage.saletitle',
    defaultMessage: 'On Sale Now | PC Game Deals and Steam Key Promotions | Fanatical',
  },
  top_sellers: {
    id: 'searchpage.topsellers',
    defaultMessage: 'Top Sellers',
  },
  latest_deals: {
    id: 'searchpage.latestdeals',
    defaultMessage: 'Latest Deals',
  },
  release_date: {
    id: 'searchpage.release_date',
    defaultMessage: 'Release Date',
  },
  top_discounts: {
    id: 'searchpage.topdiscounts',
    defaultMessage: 'Top Discounts',
  },
  price_low_to_high: {
    id: 'searchpage.pricelowtohigh',
    defaultMessage: 'Price (low-high)',
  },
  price_high_to_low: {
    id: 'searchpage.hightolow',
    defaultMessage: 'Price (high-low)',
  },
  most_wanted: {
    id: 'searchpage.mostwanted',
    defaultMessage: 'Most Wanted',
  },
  results: {
    id: 'searchpage.results',
    defaultMessage: 'Results',
  },
  results_count: {
    id: 'searchpage.resultcount',
    defaultMessage: '{resultCount} Results',
  },
  searchbar: {
    id: 'searchpage.searchbar',
    defaultMessage: 'Search PC, Mac, Linux Games',
  },
  removeFilters: {
    id: 'searchpage.remove-filters',
    defaultMessage: 'Remove All Filters',
  },
  clear: {
    id: 'searchpage.clear',
    defaultMessage: 'Clear Filters',
  },
  hideFilters: {
    id: 'searchpage.hide-filters',
    defaultMessage: 'Hide Filters',
  },
  showFilters: {
    id: 'searchpage.show-filters',
    defaultMessage: 'Show Filters',
  },
  showMore: {
    id: 'searchpage.showMore',
    defaultMessage: 'Show More',
  },
  showLess: {
    id: 'searchpage.showLess',
    defaultMessage: 'Show Less',
  },
  placeholder: {
    id: 'searchpage.placeholder',
    defaultMessage: 'Search {title}',
  },
  browseVrGames: {
    id: 'searchpage.browse.vr-games',
    defaultMessage: 'VR Games',
  },
  browseSteamDeckGames: {
    id: 'searchpage.browse.steam-deck-games',
    defaultMessage: 'Steam Deck Games',
  },
  browseGameBundles: {
    id: 'searchpage.browse.game-bundles',
    defaultMessage: 'Game Bundles',
  },
  browseGamesUnder: {
    id: 'searchpage.browse.game-under-five',
    defaultMessage: 'Game Under {price}',
  },
  browseNewUpcoming: {
    id: 'searchpage.browse.new-and-upcoming',
    defaultMessage: 'Upcoming & New Releases',
  },
  browseMultiplayerGames: {
    id: 'searchpage.browse.multiplayer',
    defaultMessage: 'Multiplayer Games',
  },
});

export default messages;
